<template>
	<div v-if="consulta && ultimaRevisao">

			<ed-form>
				<div class="row text-left">

					<ed-alert type="error" class="col-12 mb-3">
						Essa consulta está com o PCMSO desatualizado. Para continuar você deve selecionar o último PCMSO válido dessa Frente de Trabalho.
					</ed-alert>

					<div class="col-12" style="background:#c1d19c">
						<b>Último PCMSO válido: </b> 
						<span v-if="ultimaRevisao.parent">
							{{ultimaRevisao.parent.rev}} ({{ultimaRevisao.parent.descricao}} em {{$utilidade.toDate(ultimaRevisao.parent.data_hora,true)}}) /
						</span>
						<span>
							{{ultimaRevisao.rev}} ({{ultimaRevisao.descricao}} em {{$utilidade.toDate(ultimaRevisao.data_hora,true)}})
						</span>
					</div>

					<div class="col-12" style="background:#eeeeee" v-if="consulta.fdt">
						<b>Frente de Trabalho: </b> 
						<span>
							{{consulta.fdt.pcmso}} ({{consulta.fdt.descricao}})
						</span>
					</div>
					<div class="col-12" style="background:#eeeeee" v-if="consulta.revisao">
						<b>Revisão: </b> 
						<span v-if="consulta.revisao.parent">
							{{consulta.revisao.parent.rev}} ({{consulta.revisao.parent.descricao}} em {{$utilidade.toDate(consulta.revisao.parent.data_hora,true)}}) /
						</span>
						<span>
							{{consulta.revisao.rev}} ({{consulta.revisao.descricao}} em {{$utilidade.toDate(consulta.revisao.data_hora,true)}})
						</span>
					</div>
					<div class="col-12" style="background:#eeeeee" v-if="consulta.ghe">
						<b>GHE (Setor): </b> 
						<span>
							{{consulta.ghe.ghe}} ({{consulta.ghe.descricao}})
						</span>
					</div>
					<div class="col-12" style="background:#eeeeee" v-if="consulta.funcao">
						<b>Função: </b> 
						<span>
							{{consulta.funcao.nome}}
						</span>
					</div>

					<div class="col-12 mt-3">
						<h4>Selecione o novo PCMSO</h4>
					</div>

					<ed-input-select
						class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
						label="Frente de Trabalho"
						v-model="consultaNova.id_fdt"
						:items="list.fdt"
						:loading="loadingFdt"
						itemText="fdt"
						@input="getGhe"
						required
					/>

					<ed-input-select
						class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
						label="GHE (Setor)"
						v-model="consultaNova.id_ghe"
						:items="list.ghe"
						:loading="loadingGhe"
						itemText="ghe"
						@input="getFuncao"
						item-group
						required
						:disabled="!consultaNova.id_fdt"
					/>

					<ed-input-select
						class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
						label="Função"
						v-model="consultaNova.id_funcao"
						:items="list.funcao"
						:loading="loadingFuncao"
						itemText="nome"
						@input="getCredenciada"
						required
						:disabled="!consultaNova.id_ghe"
					/>

					<ed-alert type="error" class="col-12 mt-3" v-if="tabela_preco !== null">
							{{tabela_preco}}
					</ed-alert>
				</div>
			</ed-form>
		
	</div>
</template>

<script>
	
	import Fct from 'common/fct'
	import EdAlert from 'common/alert'
	import {EdForm,EdInputSelect} from 'template'

  export default {
  	components: {EdAlert,EdForm,EdInputSelect},
		mixins:[Fct],
		props:{
			consulta:{
				type:Object,
				default:function(){return null}
			},
			consultaNova:{
				type:Object,
				default:function(){return null}
			},
			ultimaRevisao:{
				type:Object,
				default:function(){return null}
			},
		},
		watch:{
			consulta(){
				this.getFdt();
			},
			'consultaNova.id_fdt'(){
				this.consultaNova.id_ghe = null;
			},
			'consultaNova.id_ghe'(){
				this.consultaNova.id_funcao = null;
			},
			'consultaNova.id_funcao'(){
				this.getCredenciada();
			},
		},
  	data () {
			return {
				list:{
					fdt:[],
					ghe:[],
					revisao:[],
					funcao:[]
				},
				tabela_preco:null,
				loadingFdt:false,
				loadingGhe:false,
				loadingFuncao:false,
				loadingRevisao:false
			}
		},

		created(){
		},

		mounted: function() {
			this.getFdt();
		},

		methods: {

			getFdt(){

				if(!this.consulta)return;

				this.loadingFdt = true 


				this.$root.$request
        .get("pcmso/fdt/"+this.consulta.empresa.id, {
        })
        .then((result) => {

					console.log('fdt',result)
					if(result.status == 200){
						this.list.fdt = result.data.data

						if(this.consultaNova.id_fdt){
							this.getGhe()
						}
					}

					this.loadingFdt = false
				})
			},

			getGhe(){
				this.loadingGhe = true ;
				this.list.ghe = [];

				this.$root.$request
        .get("pcmso/ghe/"+this.consulta.empresa.id, {
					filter:{
						id_fdt: this.consultaNova.id_fdt
					}
        })
        .then((result) => {

					console.log('ghe',result)

					if(result.status == 200){
						this.list.ghe = result.data
					}

					this.loadingGhe = false
				})
			},

			getFuncao(){
				this.loadingFuncao = true ;
				this.list.funcao = [];

				this.$root.$request
        .get("pcmso/ghe/funcao/"+this.consultaNova.id_ghe+"/"+this.consulta.empresa.id, {
					filter:{
						//id_fdt: this.consulta.id_fdt
					}
        })
        .then((result) => {

					console.log('funcao',result.data.data)

					if(result.status == 200){
						this.list.funcao = result.data.data

						let self = this
						let funcao = this.list.funcao.find(
              c => c.id == self.consulta.funcao.id
            );
						console.log('asdsdf',[funcao,this.list.funcao,self.consulta.funcao])

						this.consultaNova.id_funcao = null

						if(funcao){
							this.consultaNova.id_funcao = funcao.id
						}
					}

					this.loadingFuncao = false
				})
			},

			getCredenciada(page, search) {

				if(!this.consultaNova.id_fdt || !this.consultaNova.id_ghe || !this.consultaNova.id_funcao){
					return;
				}

      	this.$root.$loading.set(true, "Carregando exames");

      	var filter = Object.assign(
        {
          id_fdt: this.consultaNova.id_fdt,
          id_funcao: this.consultaNova.id_funcao,
          id_ghe: this.consultaNova.id_ghe,
          periodicidade: this.consulta.periodicidade,
          id_funcionario: this.consulta.funcionario.id,
          hoje: this.$utilidade.toDate(null,true),
          id_tipo_aso: [this.consulta.tipo_aso.id],
          pcd: 0,
					show_tabela_preco:1
        },
        this.formFilter
      );

      this.$root.$request
        .get("tabela-preco/"+this.consulta.empresa.id+"/"+this.consultaNova.id_fdt, {
          search: search,
          page: page,
          filter: filter,
        })
        .then((result) => {
          this.$root.$loading.set(false);

          console.log('tabela preco',result);

					this.consultaNova.id_tabela_preco = null;

          if (result.status == 200) {
            this.tabela_preco = null;

            for (let index = 0; index < result.data.length; index++) {
              let tabela_preco = result.data[index]

              if (
                (tabela_preco.credenciada &&
                  tabela_preco.credenciada.padrao == "1") ||
                index == 0
              ) {
                this.consultaNova.id_tabela_preco = tabela_preco.id;
              }
            }

						if(!this.consultaNova.id_tabela_preco){
							this.tabela_preco = 'Tabela de preço não encontrado para os dados informados.'
						}
          } 
					else{
							this.tabela_preco = result.msg
					}
        });
    },

			
		}
  }
</script>



// WEBPACK FOOTER //
// consulta-alterar-revisao.vue?77200236